export default __webpack_public_path__ + "static/media/background_landing.70baabad.svg";